// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__5RIYI","requiredAsterisk":"Info_requiredAsterisk__1gMjz"};